export const environment = {
  production: false,
  /** Url base de la aplicacion */
  // appBaseUrl: 'http://localhost:81/v1.0',
  appBaseUrl: "https://app-emp-afiliacion-masiva-api-integration.azurewebsites.net/v1.0",
  //appBaseUrl: '//40.117.63.112/portalempresasbackend/api/mallavalidadora',
  /* Url v2 afiliacion 1 - 1 */
  appBaseUrlV2: "https://cdp-as-portalempresas-afiliaciones-indiv-integracion.azurewebsites.net/api",
  //reportemasivo: '//40.117.63.112/reportemasivo/api/v1',
  REPORTE_MASIVO:
    "https://app-emp-reporte-masivo-publicador-api-test.azurewebsites.net/v1.0",
  /*Reporte masivo conteo*/
  REPORTE_MASIVO_CONTEO:
    "https://app-emp-reporte-masivo-subscriptor-api-test.azurewebsites.net/v1.0",
  /*Auth Reporte masivo*/
  AUTH_REPORTE_MASIVO: "Ker67Wt?Az2Q3",
  /* Url Authentication */
  AUTH_ENDPOINT: "http://40.117.63.112/authtransactional/api",
  /* Url validador */
  END_POINT_VALIDATE:
    "https://cdp-as-portalempresas-malla-valregistro-integration.azurewebsites.net/api/transaccional/validationAffiliate",
  URL_API_VALIDAR_EMPRESA:
    "https://app-empresas-validador-afiliacion-api-test.azurewebsites.net/v1.0/api/transaccional/validationAffiliate",
  //END_POINT_VALIDATE: 'https://transacciones.colsubsidio.com/portalempresas/api/validador/registro/api/transaccional/validationAffiliate',
  //END_POINT_VALIDATE: 'http://localhost:84/api/transaccional/validationAffiliate',
  /* Url orquestador */
  END_POINT_OSQUESTADOR: "https://cdp-portalempresas-orquestador-test.azurewebsites.net/api",
  /* Url cuota monetaria */
  END_POIN_CUOTAM: "https://cdp-as-portalempresas-cuota-monetaria-test.azurewebsites.net",
  /*Url descarga info trab*/
  END_POIN_DESC_INFO_TRAB: "https://cdp-as-portalempresas-descargar-infotrab-test.azurewebsites.net/api",
  /* Url Logout */
  API_AUTH: "https://cdp-as-transversal-ssob-integration.azurewebsites.net/api/transaccional",
  /** Url de configuracion de usuarios sin permiso no autenticado */
  notAutenticationRedirect:
    "https://www.colsubsidio.com/ssob/#/ingresar?goto=http://localhost:4200",
  // notAutenticationRedirect: 'https://www.colsubsidio.com/ssob/#/ingresar?goto=http://40.117.63.112/portalempresas',
  /* Token user */
  loginUserToken: "appLoginUserToken",
  /* Informacion de la empresa */
  businessInformation: "businessInformation",
  /* Informacion de la empresa */
  notificationInformation: "notification",
  /* Token de autorizacion */
  Authorization: "token",
  /*control para visualización de modal para información importante o noticia, ejemplo modificación del xls masivo*/
  infoShow: "infoShow",
  /* Usuario loggeado */
  userloggedin: "userloggedin",
  /* Informacion del usuario registrado en colsubsidio */
  dataAffiliate: "dataAffiliate",
  /*Funcionalidad RNEC */
  RNEC_ACTIVO: false,
  /* Url envio email */
  EMAIL_ENDPOINT:
    "https://transacciones.colsubsidio.com/correos/api/v1/email?name=certificado_afiliacion.pdf",
  /** Definicion de la url de redireccion para errores */
  errorPageRedirect: "",
  /* Url certificados */
  CERTIFICATION_ENDPOINT:
    "https://afiliacionescertificados-integration-hfafa5fdc6byh7e7.eastus-01.azurewebsites.net/api/transaccional/certificados",
  /*Url Reportes Historicos Afiliaciones*/
  REPORT_AFFILIATIONS:
    "https://cdp-as-portalempresas-afiliacion-histori-test.azurewebsites.net/v1.0",
  /*CUOTA SUBSIDIO FAMILIAR*/
  MONETARY_FEE:
    "https://app-emp-cuota-subsidio-familiar-api-test.azurewebsites.net/v1.0",
  /*SUBSIDIO ESCOLAR*/
  SHOOL: "https://app-emp-subsidio-escolar-api-test.azurewebsites.net/v1.0",


  /*GESTOR DE CONTENIDO*/
  //CONTENT_MANAGER : 'http://40.117.63.112/portalempresas/gestor/v1.0',
  CONTENT_MANAGER: "https://app-empresas-gestion-gestor-dru-test.azurewebsites.net/gestor",
  //CONTENT_MANAGER : "https://transacciones.colsubsidio.com/portalempresas/gestor/dru/gestor",


  /* Manual ayuda carga masiva  */
  url_manuel_cm:
    "https://colsstoragedigitalpru.blob.core.windows.net/malla/123AD/Manual de Usuario Afiliaciones Masivas_v1.pdf",
  /* Variable para guardar el response cuando una afiliacion masiva tiene errores */
  mass_response_error: "massResponseError",
  /* Nombre archivo masivo de afiliacion */
  name_file_mass: "name_file_mass",
  /* Informacion del trabajador */
  workerInformation: "workerInformation",
  /*Filtros info trabajador*/
  workerFilter: "workerFilter",
  /*Informacion de histoAffiliacion*/
  affiliateInformation: "affiliateInformation",
  /*Informacion del trabajador*/
  crpworkerInformation: "crpworkerInformation",
  /* Informacion cuota monitaria trabajador */
  monetaryFee: "monetaryFee",
  /* Movimientos cuota monetaria*/
  movementsMonetaryFee: "movementsMonetaryFee",
  /* Movimientos subsidio escolar*/
  movementsSchollAllowance: "movementsSchollAllowance",
  /* Movimientos debitos subsidio escolar*/
  movementsDebitSchollAllowance: "movementsDebitSchollAllowance",
  /*Pass Crytp*/
  passCrypt: "1234",
  /*Contenido de gestor*/
  contentManager: "contentManager",
  /* Accesso a pqrs*/
  END_POINT_PQRS: "https://cdp-as-transversal-tpclient-manager-test.azurewebsites.net/v1.0",
  /* Url de api de gestion de pqrs con TPClient */
  END_POINT_PQRS_GESTION:
    "https://app-emp-pqrs-gestion-api-test.azurewebsites.net/v1.0",
  pqrOrganizationId: "ACME",
  pqrRelationId: "CLCO1",
  pqrRelationIdOtros: "ED",
  pqrCustomerTypeId: "S_CLIECO",
  pqrClassifierNivelBase: "COCLCO",
  pqrClassifierNivelBaseOtros: "INOT",
  pqrLanguage: "es",
  pqrSearchType: "3",

  disaffiliate_massive:
    "https://app-empresas-desafiliacion-masiva-api-test.azurewebsites.net/v1.0",
  URL_AZURE: "https://sttidev.blob.core.windows.net/portales-integracion/",
  URL_OBLIGATORIEDAD_DOCUMENTOS:
    "https://app-trans-empresas-consultas-solicitudes-integration.azurewebsites.net/v1.0/request/documents?",
  // appBaseUrlRequest: 'http://40.117.63.112/portalempresas/gestorsolicitudes/cliente/v1.0',
  appBaseUrlRequest:
    "https://app-trans-gestor-solicitudes-cliente-api-integration.azurewebsites.net/v1.0",
  // appBaseUrlRequest: 'http://localhost:83/v1.0',
  /* Url del api de administracion de las solicitudes en el gestor de solicitudes */
  REQUEST_MANAGER:
    "https://app-trans-gestor-solicitudes-autorizador-test.azurewebsites.net/v1.0",
  REQUEST_QUERY:
    "https://app-trans-empresas-consultas-solicitudes-integration.azurewebsites.net/v1.0",
  //REQUEST_MANAGER: 'http://localhost:82/v1.0',

  /*Acreditación cuota monetaria*/
  acreditacionCuotaMonetaria:
    "https://app-emp-acreditacion-cuota-monetaria-cliente-api-test.azurewebsites.net/v1.0/customer/",
  acreditacionCuotaMonetariaRequest: "solicitudes",
  acreditacionCuotaMonetariaRequestMassive: "solicitudes/masiva",
  acreditacionCuotaMonetariaLoadFile: "archivo/cargar/",
  acreditacionCuotaMonetariaDeleteFile: "archivo/eliminar",
  acreditacionCuotaMonetariaGenerateAfiliatonFile:
    "archivo/fomatos/afiliacion/",
  acreditacionCuotaMonetariaGenerateUnderOathFile:
    "archivo/fomatos/bajojuramento/",

  disaffiliateInformation: "disaffiliateInformation",
  certificateStateAccountMonetary: "certificateStateAccountMonetary",
  certificateStateAccountMonetaryFormat:
    "certificateStateAccountMonetaryFormat",
  /* Url del api de retiro de trabajadores y beneficiarios */
  RETREAT: "http://40.117.63.112/portalempresas/api/retreat/v1.0",
  END_POIN_STATE_ACCOUNT_CUOTAM:
    "https://api-personas-estado-cuenta-subsidio-fami-test.azurewebsites.net/api/estado/cuenta/reporte",
  END_POINT_CONSULTA_RNEC:
    "https://app-empresas-consulta-rnec-api-test.azurewebsites.net/v1.0/consulta/BI",
  tokenSASBlobMassive:
    "?sv=2021-10-04&st=2023-07-25T16%3A45%3A45Z&se=2025-12-31T16%3A45%3A00Z&sr=b&sp=r&sig=YLHdQy7Dx7nnsqixdcSdhg832eM08NbXajiefaKMEBI%3D",
  tokenSASBlobRetreatMassive:
    "?sv=2021-10-04&st=2023-07-27T13%3A01%3A27Z&se=2025-07-28T13%3A01%3A00Z&sr=b&sp=r&sig=IOWE38dLx%2FwWxxr%2B21%2FaYGwUPiUdfljnqiLYswshHbI%3D",
  MINIMUN_SALARY:1750905,
  SALARIO_MAXIMO_SAP:100000000,

  CIAM_PREFIX: "ColsubB2B",
  CIAM_API_KEY: "4_9nsax5GbPCg5CRmjaMTBZw",
  CIAM_TYPE_MARKETING: "B2B",
  CIAM_VAR_USERDATA: "sso_empresa",
  CIAM_VAR_AUTHDATA: "decode-jwt-sso_empresa",
  CIAM_VAR_ORGANIZATION: "x-Colsubsidio-Organizacion-x",
  CIAM_API_VIEW_LITE: false,
  CIAM_API_PREFIX: "ColsubB2B",
  CIAM_API_CDN_URL: "https://loginqaemp.transacciones.colsubsidio.com",
  CIAM_URL_AUTHENTICATION_CIAM: "https://app-tra-auth-ciam-api-develop.azurewebsites.net/v1.0/authciam/signin",
  CIAM_COUNT_AUTH: 4,
  URL_CONTEXT: '',
};
